// src/components/legal/WorkoutTermsOfService.js
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Container = styled.div`
    max-width: 800px;
    margin: 0 auto;
    padding: 3rem 2rem;
    line-height: 1.8;
    color: #333;
`;

const Header = styled.header`
    text-align: center;
    margin-bottom: 3rem;
    padding-bottom: 2rem;
    border-bottom: 2px solid #eee;
`;

const Title = styled.h1`
    font-size: 2.5rem;
    margin-bottom: 1rem;
    color: #FF6B6B;
`;

const UpdateDate = styled.p`
    color: #666;
    font-size: 1rem;
`;

const BackLink = styled(Link)`
    display: inline-flex;
    align-items: center;
    color: #FF6B6B;
    text-decoration: none;
    margin-bottom: 2rem;
    transition: opacity 0.3s;
    
    &:hover {
        opacity: 0.8;
    }
    
    &::before {
        content: '←';
        margin-right: 0.5rem;
    }
`;

const Section = styled.section`
    margin-bottom: 2.5rem;
`;

const SectionTitle = styled.h2`
    font-size: 1.5rem;
    margin-bottom: 1rem;
    color: #444;
`;

const Paragraph = styled.p`
    margin-bottom: 1rem;
    text-align: justify;
    white-space: pre-wrap;
`;

const CompanyInfo = styled.div`
    background: #f8f9fa;
    padding: 1.5rem;
    border-radius: 10px;
    margin-bottom: 2rem;
    white-space: pre-wrap;
`;

const InfoBox = styled.div`
    background: #e8f5e9;
    padding: 1.5rem;
    border-radius: 10px;
    margin: 2rem 0;
    white-space: pre-wrap;
`;

const WorkoutTermsOfService = () => {
    return (
        <Container>
            <BackLink to="/workout">Mind Workout으로 돌아가기</BackLink>

            <Header>
                <Title>Mind Workout 이용약관</Title>
                <UpdateDate>최종 수정일: 2025년 8월 1일</UpdateDate>
            </Header>

            <CompanyInfo>
                <SectionTitle>사업자 정보</SectionTitle>
                <Paragraph>
                    • 상호: 마인드월드(MindWorld)
                    • 대표자: 윤우재
                    • 주소: 경기도 의왕시 시청1로 11
                    • 사업자등록번호: 504-43-28680
                    • 고객센터: mind-wellness@naver.com
                </Paragraph>
            </CompanyInfo>

            <Section>
                <SectionTitle>제1조 (목적 및 적용범위)</SectionTitle>
                <Paragraph>
                    이 약관은 마인드월드(이하 "회사")가 제공하는 마인드 워크아웃 모바일 애플리케이션 및 관련 서비스(이하 "서비스")의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.

                    본 서비스를 이용함으로써 귀하는 본 약관에 동의하는 것으로 간주됩니다. 본 약관에 동의하지 않으시면 서비스를 이용하실 수 없습니다.
                </Paragraph>
            </Section>

            <Section>
                <SectionTitle>제2조 (서비스의 정의 및 내용)</SectionTitle>
                <Paragraph>
                    마인드 워크아웃은 사용자의 정신력 향상을 위한 체계적인 훈련 플랫폼으로 다음 서비스를 제공합니다:

                    • 집중력 훈련 (SART, CPT 등 6개 훈련 프로그램)
                    • 인내력 훈련 (지연만족 훈련 등 5개 프로그램)
                    • 감정조절력 훈련 (인지재평가 등 6개 프로그램)
                    • 공감력 훈련 (표정 인식 등 5개 프로그램)
                    • 레벨 시스템 및 경험치 관리
                    • 개인화된 훈련 성과 분석 및 피드백
                    • 일일 훈련 목표 및 연속 훈련 보상

                    중요: 본 서비스는 정신력 향상 및 자기계발 목적으로만 제공되며 의료행위에 해당하지 않습니다.
                </Paragraph>
            </Section>

            <Section>
                <SectionTitle>제3조 (의료행위 면책 및 안전 고지)</SectionTitle>
                <Paragraph>
                    중요 안내: 본 서비스는 의료 서비스가 아니며 전문적인 의료 진료를 대체할 수 없습니다.

                    본 서비스가 도움을 줄 수 있는 영역:
                    • 집중력 및 주의력 향상
                    • 인내심과 자제력 강화
                    • 감정 인식 및 조절 능력 개발
                    • 타인에 대한 이해와 공감 능력 향상
                    • 일상적인 정신력 단련

                    본 서비스가 제공할 수 없는 것:
                    • 의학적 진단, 치료, 처방
                    • 전문 상담 또는 심리치료 대체
                    • 위기 개입 서비스
                    • 정신질환 치료

                    심각한 우울감, 자해 충동, 자살 생각이 드시거나 일상생활에 심각한 지장이 있으실 경우 반드시 해당 지역의 응급서비스나 전문가와 상담받으시기 바랍니다.
                </Paragraph>
            </Section>

            <Section>
                <SectionTitle>제4조 (회원가입 및 계정 관리)</SectionTitle>
                <Paragraph>
                    특정 기능을 이용하시려면 정확하고 최신의 완전한 정보를 제공하여 계정을 생성하셔야 합니다.

                    회원의 책임사항:
                    • 계정 정보의 기밀성 유지
                    • 계정 하에서 발생하는 모든 활동에 대한 책임
                    • 무단 사용 발견 시 즉시 신고
                    • 가입 시 정확한 정보 제공

                    본 약관을 위반하거나 허위 정보를 제공한 계정은 정지 또는 해지될 수 있습니다.
                </Paragraph>
            </Section>

            <Section>
                <SectionTitle>제5조 (유료서비스 및 결제 약관)</SectionTitle>
                <Paragraph>
                    프리미엄 기능: 일부 기능은 유료 구독이 필요합니다.

                    결제 관련 사항:
                    • 구독료는 반복 결제 방식으로 사전 청구됩니다
                    • 요금은 앱스토어를 통해 현지 통화로 표시됩니다
                    • 결제는 Apple App Store 또는 Google Play Store에서 처리됩니다
                    • 무료 체험 기간이 제공될 수 있습니다

                    구독 취소:
                    • 앱스토어 계정 설정에서 언제든지 구독을 취소할 수 있습니다
                    • 취소는 현재 결제 기간 종료 시점부터 적용됩니다
                    • 법적으로 요구되는 경우를 제외하고 부분 환불은 제공되지 않습니다

                    자동 갱신:
                    • 구독은 갱신일 전에 취소하지 않는 한 자동으로 갱신됩니다
                    • 앱스토어 계정 설정에서 자동 갱신을 관리할 수 있습니다
                </Paragraph>
            </Section>

            <Section>
                <SectionTitle>제6조 (개인정보 보호 및 데이터 처리)</SectionTitle>
                <Paragraph>
                    회사는 귀하의 개인정보를 중요하게 생각하며 보호하기 위해 최선을 다합니다.

                    데이터 수집:
                    • 서비스 제공에 필요한 최소한의 정보만 수집합니다
                    • 훈련 기록 및 성과 데이터는 명시적 동의 하에 처리됩니다
                    • 모든 데이터는 암호화되어 안전하게 저장됩니다

                    귀하의 권리:
                    • 개인정보 열람, 수정, 삭제 요구
                    • 데이터 이동성 (데이터 내보내기)
                    • 데이터 처리 동의 철회
                    • 계정 삭제 요청

                    자세한 사항은 개인정보처리방침을 참조하시기 바랍니다.
                </Paragraph>
            </Section>

            <Section>
                <SectionTitle>제7조 (이용자의 책임 및 금지행위)</SectionTitle>
                <Paragraph>
                    귀하는 다음 사항을 이해하고 서비스를 책임감 있게 이용하시기 바랍니다:

                    • 본 서비스는 정신력 훈련 도구이며 의료 치료가 아닙니다
                    • 훈련 결과에 대한 책임은 이용자에게 있습니다
                    • 필요시 전문가의 도움을 받으시기 바랍니다
                    • 서비스는 개인적, 비상업적 용도로만 사용 가능합니다

                    금지행위:
                    • 허위 또는 오해를 불러일으키는 정보 제공
                    • 서비스 해킹 또는 역공학 시도
                    • 불법적 목적으로 서비스 사용
                    • 계정 정보 타인과 공유
                </Paragraph>
            </Section>

            <Section>
                <SectionTitle>제8조 (지적재산권)</SectionTitle>
                <Paragraph>
                    본 서비스의 모든 콘텐츠, 기능 및 기능성은 회사가 소유하며 국제 저작권, 상표권 및 기타 지적재산권법에 의해 보호됩니다.

                    금지사항:
                    • 당사 콘텐츠의 복사, 배포 또는 수정
                    • 허가 없는 상표 사용
                    • 서비스 기반 파생 작품 생성
                    • 저작권 또는 소유권 표시 제거
                </Paragraph>
            </Section>

            <Section>
                <SectionTitle>제9조 (책임의 제한)</SectionTitle>
                <Paragraph>
                    법률이 허용하는 최대 범위에서:

                    • 본 서비스는 "있는 그대로" 보증 없이 제공됩니다
                    • 회사는 간접적, 우발적 또는 결과적 손해에 대해 책임지지 않습니다
                    • 회사의 총 배상책임은 클레임 발생 전 12개월간 귀하가 지불한 서비스 이용료로 제한됩니다
                    • 회사는 본 서비스를 기반으로 한 귀하의 결정에 대해 책임지지 않습니다

                    일부 지역에서는 책임 제한이 적용되지 않을 수 있으므로 위 제한사항이 귀하에게 적용되지 않을 수 있습니다.
                </Paragraph>
            </Section>

            <Section>
                <SectionTitle>제10조 (서비스 이용가능성 및 변경)</SectionTitle>
                <Paragraph>
                    회사는 서비스 가용성을 유지하기 위해 노력하지만 중단 없는 접근을 보장할 수는 없습니다.

                    회사는 다음 권한을 보유합니다:
                    • 서비스의 일부 또는 전부를 수정, 중단, 중지
                    • 합리적인 통지와 함께 본 약관 업데이트
                    • 필요에 따른 유지보수 또는 업데이트 시행

                    중대한 변경사항이 있을 경우 합리적으로 가능한 범위에서 사전 통지해드립니다.
                </Paragraph>
            </Section>

            <Section>
                <SectionTitle>제11조 (계약의 해지)</SectionTitle>
                <Paragraph>
                    양 당사자 모두 본 계약을 해지할 수 있습니다:

                    • 귀하는 언제든지 서비스 이용을 중단하고 계정을 삭제할 수 있습니다
                    • 회사는 본 약관 위반 시 귀하의 접근을 중단 또는 해지할 수 있습니다
                    • 해지 시 서비스 이용 권한은 즉시 중단됩니다
                    • 본 약관의 일부 조항(개인정보보호, 지적재산권)은 해지 후에도 유효합니다
                </Paragraph>
            </Section>

            <Section>
                <SectionTitle>제12조 (분쟁해결 및 준거법)</SectionTitle>
                <Paragraph>
                    본 약관의 해석 및 적용에 관해서는 대한민국 법률을 준거법으로 합니다. 단, 사용자 거주 국가의 강행 법규(소비자 보호법 등)가 대한민국 법률보다 사용자에게 더 강력한 보호를 제공하는 경우에는 해당 법규가 우선 적용될 수 있습니다.

                    분쟁 해결:
                    본 약관과 관련하여 회사와 이용자 간에 발생하는 분쟁은 먼저 상호 협의를 통해 원만히 해결하도록 노력합니다.
                    협의로 해결되지 않는 경우, 대한민국 서울중앙지방법원을 전속적 관할 법원으로 합니다. 단, 사용자 거주 국가의 법률에 따라 해당 국가의 법원이 관할권을 가지는 경우에는 해당 법원이 관할 법원이 될 수 있습니다.
                </Paragraph>
            </Section>

            <Section>
                <SectionTitle>제13조 (문의처)</SectionTitle>
                <Paragraph>
                    본 약관 또는 서비스에 대한 문의사항이 있으시면 다음으로 연락주시기 바랍니다:

                    이메일: mind-wellness@naver.com

                    합리적인 시간 내에 답변해드리겠습니다.
                </Paragraph>
            </Section>

            <InfoBox>
                <SectionTitle>약관 정보</SectionTitle>
                <Paragraph>
                    • 제정일: 2025년 8월 1일
                    • 최종 수정일: 2025년 8월 1일
                    • 시행일: 2025년 8월 1일
                    • 버전: 1.0
                    • 본 약관의 정본은 한국어이며, 다른 언어로 번역된 약관과의 불일치가 있는 경우 한국어 약관이 우선합니다.
                </Paragraph>
            </InfoBox>
        </Container>
    );
};

export default WorkoutTermsOfService;
